var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('base-dialog', {
    model: {
      value: _vm.isVisible,
      callback: function callback($$v) {
        _vm.isVisible = $$v;
      },
      expression: "isVisible"
    }
  }, [_c('dialog-template', [_c('div', {
    attrs: {
      "slot": "title"
    },
    domProps: {
      "textContent": _vm._s(_vm.displayTitle)
    },
    slot: "title"
  }), _c('template', {
    slot: "content"
  }, [_c(_vm.displayComponent, {
    tag: "component",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "refund-debit": _vm.handleRefundDebit,
      "refund-bill": _vm.handleRefundBill,
      "change-data": _vm.handleChangeRefundData
    }
  }), _vm.currentStep === 1 ? _c('div', {
    class: _vm.$style.footer,
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    class: [_vm.$style.action, _vm.$style.submit]
  }, [_c('simple-button', {
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.agree')) + " ")])], 1), _c('div', {
    class: _vm.$style.action
  }, [_c('simple-button', {
    attrs: {
      "variant": "transparent"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)]) : _vm._e(), _vm.currentStep === 2 ? _c('div', {
    class: _vm.$style.footer,
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('simple-button', {
    attrs: {
      "variant": "transparent"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1) : _vm._e(), _vm.currentStep === 3 ? _c('div', {
    class: _vm.$style.footer,
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    class: [_vm.$style.action, _vm.$style.submit]
  }, [_c('simple-button', {
    attrs: {
      "disabled": _vm.isInvalid
    },
    on: {
      "click": _vm.handleRefund
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.send')) + " ")])], 1), _c('div', {
    class: _vm.$style.action
  }, [_c('simple-button', {
    attrs: {
      "variant": "transparent"
    },
    on: {
      "click": function click($event) {
        _vm.currentStep = 1;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)]) : _vm._e()], 1)], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }